import styled from "styled-components";

export const Container = styled.div`
  position: relative;
  height: 100%;
  display: flex;
  align-items: center;
  width: 458px;

  @media screen and (max-width: 900px) {
    width: 339px;
  }

  @media screen and (max-width: 768px) {
    width: 339px;
  }
`;

export const InputContainer = styled.div`
  display: inherit;
  flex-direction: row;
  width: 100%;
  align-items: center;
`;

export const SearchButton = styled.button`
  display: inherit;
  justify-content: center;
  align-items: center;
  width: 39px;
  height: 40px;
  border: 1px solid #ddddde;
  padding-top: 5px;
  background-color: #c4c4c4;
  cursor: pointer;
`;

export const SearchUl = styled.ul`
  position: absolute;
  background: #fff;
  max-height: 500px;
  overflow: auto;
  top: 56px;
  margin: 0;
  width: 100%;
  padding: 0;
  list-style-type: none;
  filter: drop-shadow(0 4px 4px rgba(0, 0, 0, 0.25));

  @media screen and (max-width: 900px) {
    top: 100%;
  }

  @media screen and (max-width: 768px) {
    top: 100%;
  }
`;

export const SearchInput = styled.input`
  border: none;
  background: white;
  outline: none;
  line-height: 16px;
  height: 39px;
  width: 100%;
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 16px;
  color: #696057;
  padding: 0 20px;
`;
